import { Pipe, PipeTransform } from '@angular/core';
import { Printer } from 'src/app/views/models/printer.model';

@Pipe({
  name: 'printerAliasController'
})
export class PrinterAliasControllerPipe implements PipeTransform {

  transform(alias: string, hostName: string, printerQues: Printer[]): boolean {
    return Boolean(printerQues.find(x => x.host_name === hostName && x.printer_alias === alias));
  }

}
